import React, { useState, useEffect } from 'react';
import * as api from './api';
function NaughtyNiceSearch({ onCountrySelect }) {
  const [name, setName] = useState('');
  const [responseName, setResponseName] = useState(''); // Static name for the response
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [followUpQuestion, setFollowUpQuestion] = useState(null);
  const [countries, setCountries] = useState(['World']); // Default country list
  const [selectedCountry, setSelectedCountry] = useState('World');
  const [showHeatmapLegend, setShowHeatmapLegend] = useState(false);  
   
  const luceniaEmployees = [
    'Nicholas Knize',
    'Maria Carrero',
    'Wes Richardet',
    'Allison Richardet',
    'Dalton Boggs',
  ];

  // Fetch countries for the dropdown
  useEffect(() => {
    const getCountryList = async () => {
      const countries = await api.fetchCountries();
      setCountries(countries);
    };

    getCountryList();
  }, []);

  // Handle name search
  const handleNameSearch = async () => {
    if (!name.trim()) return;

    setLoading(true);
    setResult(null);
    setFollowUpQuestion(null);

    if (
      luceniaEmployees.some(
        (employee) => name.toLowerCase() === employee.toLowerCase(),
      )
    ) {
      setTimeout(() => {
        setResponseName(name);
        setName('');
        setResult({ status: 'Nice', color: 'green' });
        setLoading(false);
      }, 1000);
      return;
    }

    try {
      const response = await api.nameSearch(name, selectedCountry);

      const content = response.data.choices[0]?.message?.content || '';

      if (content.toLowerCase().includes('question:')) {
        setFollowUpQuestion(content);
      } else if (content.toLowerCase().includes('naughty')) {
        setResponseName(name);
        setName('');
        setResult({ status: 'Naughty', color: 'red' });
      } else if (content.toLowerCase().includes('nice')) {
        setResponseName(name);
        setName('');
        setResult({ status: 'Nice', color: 'green' });
      } else {
        await handleFollowUp();
      }
    } catch (error) {
      console.error('Error determining Naughty/Nice status:', error);
      setResponseName(name);
      setName('');
      setResult({ status: 'Error determining status', color: 'gray' });
    } finally {
      setLoading(false);
    }
  };

  const handleFollowUp = async () => {
    setLoading(true);
    setFollowUpQuestion(null);

    try {

      const followUpResponse = await api.handleFollowUp(responseName);

      const content = followUpResponse.data.choices[0]?.message?.content || '';
      if (content.toLowerCase().includes('naughty')) {
        setResponseName(responseName);
        setName('');
        setResult({ status: 'Naughty', color: 'red' });
      } else if (content.toLowerCase().includes('nice')) {
        setResponseName(responseName);
        setName('');
        setResult({ status: 'Nice', color: 'green' });
      } else {
        setResult({ status: 'Undetermined', color: 'gray' });
      }
    } catch (error) {
      console.error('Error during follow-up determination:', error);
      setResult({ status: 'Error determining status', color: 'gray' });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = async (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      await handleNameSearch();
    }
  };

  const handleInputChange = (e) => {
    setName(e.target.value);
    if (!e.target.value.trim()) {
      setResult(null);
      setFollowUpQuestion(null);
    }
  };

  const handleCountryChange = (e) => {
    const selectedId = e.target.value; // The selected ID from the dropdown
    const selectedCountry = countries.find((c) => c.id === selectedId); // Find the full object
  
    setSelectedCountry(selectedId); // Update local state with the ID
    if (selectedCountry) {
        console.log("Selected country:", selectedCountry);
        onCountrySelect(selectedCountry);
        setShowHeatmapLegend(true); // Show legend on valid selection
    } else {
        console.warn("Invalid country selection.");
        setShowHeatmapLegend(false); // Hide legend on invalid selection
    }
  };

  return (
    <div className="naughty-nice-search">
      <h2>Naughty/Nice Search</h2>
      <div className="country-filter">
        <label htmlFor="country-select">Select Country:</label>
        <select
          id="country-select"
          value={selectedCountry}
          onChange={handleCountryChange}
          disabled={loading}
        >
          {countries.map((country, index) => (
            <option key={country.id || index} value={country.id}>
              {country.name}
            </option>
          ))}
        </select>
      </div>
      <input
        type="text"
        value={name}
        onChange={handleInputChange}
        onKeyDown={handleKeyPress}
        placeholder="Enter name"
        disabled={loading}
      />
      <button onClick={handleNameSearch} disabled={loading}>
        {loading ? 'Checking...' : 'Search'}
      </button>
      {followUpQuestion && (
        <div className="follow-up">
          <p>{followUpQuestion}</p>
        </div>
      )}
      {result && (
        <p style={{ color: result.color }}>
          <strong>{responseName}:</strong> {result.status}
        </p>
      )}
    </div>
  );
}

export default NaughtyNiceSearch;
